export const BANKING_PAYMENT_TYPE = {
  DEPOSIT: 'deposit',
  TRANSFER: 'transfer',
  WITHDRAW: 'withdraw',
  WIRE: 'wire'
};
